module.exports = __webpack_public_path__ + "img/FI01123053.80b2cf14.png";